/**
 * Format a value for HTML `datetime-local` inputs (`YYYY-MM-DDTHH:mm`).
 * Safe for API/form values that may be null, empty, or invalid — never throws.
 */
export function formatDateForDateTimeLocal(value: unknown): string {
  if (value === null || value === undefined) {
    return ''
  }

  let normalized = ''

  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return ''
    }
    normalized = value.toISOString()
  } else if (typeof value === 'string') {
    normalized = value.trim()
  } else if (typeof value === 'number' && Number.isFinite(value)) {
    const numericDate = new Date(value)
    if (isNaN(numericDate.getTime())) {
      return ''
    }
    normalized = numericDate.toISOString()
  } else {
    return ''
  }

  if (!normalized) {
    return ''
  }

  let date: Date
  if (normalized.endsWith('Z')) {
    // Match legacy channel-settings parsing (strip trailing Z + fractional seconds tail).
    date = new Date(normalized.slice(0, normalized.length - 4))
  } else {
    date = new Date(normalized)
  }

  if (isNaN(date.getTime())) {
    return ''
  }

  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  if (isNaN(localDate.getTime())) {
    return ''
  }

  try {
    return localDate.toISOString().slice(0, 16)
  } catch {
    return ''
  }
}
